import type { TowerDesign } from "@/game/towerSpec";
import type { Material } from "@/physics/model";
const A572_65: Material = { name: "A572 Gr65", E: 200e9, Fy: 448e6, rho: 7850 };
/** EXACT: 4-sided monopole, base OD 47.1in -> top 16in (tnxTower), 125 mph, 2.00in ice. Grade A572-65 assumed. Foundation pier estimated. */
export const design: TowerDesign = {
  id: "monopole-southington-160ft",
  name: "Monopole (Southington 160 ft)",
  description: "Real 160 ft 4-sided monopole, Southington CT (125 mph, 2in ice).",
  author: "reference: 02_engineering_drawings",
  spec: {
    type: "monopole",
    height: 48.77,
    stack: { faces: 4, panels: 16, baseRadius: 0.598, topRadius: 0.203,
      legSection: "legXXL", braceSection: "braceHeavy", legMaterial: A572_65, braceMaterial: A572_65, bracing: "X" },
    shell: { baseDiameter: 1.196, topDiameter: 0.406 },
    foundation: { soil: "dense-sand",
      base: { type: "pier", width: 3.0, diameter: 3.0, depth: 8.0, concrete: "c30" },
      connection: { kind: "anchorBolts", nBolts: 12, bolt: "b1_75", grade: "f1554_105", boltCircleDia: 1.2, embedment: 0.45, edgeDistance: 0.3, platePlanArea: 1.8, plateThickness: 0.05, plateGrade: "a36rod", fc: 30e6 } },
  },
};
